import { getAuthenticatedRequestInit } from './utils';

export interface PhoneUserIdentity {
	gr_user?: number;
	email?: string;
	first_name?: string;
	last_name?: string;
	poster?: string;
}

export async function SendDtmf(token: string, meetingId: string, sipConnectionId: string, digits: string) {
	const url = `${process.env.REACT_APP_API_HOST}/v2/greenroom/dial-phone/${meetingId}/${sipConnectionId}/dtmf`;
	try {
		const res = await fetch(url, {
			method: 'POST',
			body: JSON.stringify({ digits }),
			...getAuthenticatedRequestInit(token),
		});
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		return { ok: false, message: text };
	} catch (e) {
		return { ok: false, message: 'Connection Error' };
	}
}

export async function HangupPhoneByUser(token: string, meetingId: string, grUser: number | string) {
	const url = `${process.env.REACT_APP_API_HOST}/v2/greenroom/dial-phone/${meetingId}/by-user/${grUser}`;
	try {
		const res = await fetch(url, { method: 'DELETE', ...getAuthenticatedRequestInit(token) });
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		return { ok: false, message: text };
	} catch (e) {
		return { ok: false, message: 'Connection Error' };
	}
}

export async function HangupAllPhones(token: string, meetingId: string) {
	const url = `${process.env.REACT_APP_API_HOST}/v2/greenroom/dial-phone/${meetingId}/all`;
	try {
		const res = await fetch(url, { method: 'DELETE', ...getAuthenticatedRequestInit(token) });
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		return { ok: false, message: text };
	} catch (e) {
		return { ok: false, message: 'Connection Error' };
	}
}

export async function HangupPhone(token: string, meetingId: string, sipConnectionId: string) {
	const url = `${process.env.REACT_APP_API_HOST}/v2/greenroom/dial-phone/${meetingId}/${sipConnectionId}`;
	try {
		const res = await fetch(url, {
			method: 'DELETE',
			...getAuthenticatedRequestInit(token),
		});
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		console.error('[HangupPhone] error response', res.status, text);
		return { ok: false, message: text };
	} catch (e) {
		console.error('[HangupPhone] fetch error', e);
		return { ok: false, message: 'Connection Error' };
	}
}

export default async function DialPhone(
	token: string,
	phoneNumber: string,
	meetingId: string,
	userIdentity?: PhoneUserIdentity,
) {
	const url = `${process.env.REACT_APP_API_HOST}/v2/greenroom/dial-phone/${meetingId}`;
	console.log('[DialPhone] calling', url, { phoneNumber, userIdentity, hasToken: !!token, meetingId });
	try {
		const res = await fetch(url, {
			method: 'POST',
			body: JSON.stringify({ phoneNumber, userIdentity }),
			...getAuthenticatedRequestInit(token),
		});
		console.log('[DialPhone] response status', res.status);
		if (res.ok) return res.json();
		const text = await res.text();
		console.error('[DialPhone] error response', res.status, text);
		return { message: `Response Error (${res.status}): ${text}` };
	} catch (e) {
		console.error('[DialPhone] fetch error', e);
		return { message: 'Connection Error' };
	}
}
